import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        dialog: {
            justifyContent: 'flex-start',
        },
        smallMap: {
            flexDirection: 'column',
            display: 'flex',
            height: 'calc(100% - 55px)',
        },
        map: {
            height: '100%',
        },
        gridPane: {
            display: 'flex',
            height: '100vh',
        },
        formPane: {
            display: 'flex',
            position: 'absolute',
            minHeight: '100%',
            top: 0,
            right: 0,
            left: 0,
        },
        pageWrapper: {
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
        },
        wrapper: {
            display: 'flex',
            position: 'relative',
            flexGrow: 1,
            flexDirection: 'column',
            width: '100%',
        },
        paneWrapper: {
            position: 'absolute',
            top: 0,
            left: 'calc(100% - 400px)',
            width: 400,
            maxHeight: '100%',
            right: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            display: 'flex',
            height: '100%',
            zIndex: 200,
        },

        pageContent: {
            position: 'absolute',
            top: 10,
            left: 10,
            bottom: 10,
            right: 10,
            [theme.breakpoints.down('sm')]: {
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
            },
        },

        container: {
            height: '100%',
        },

        formWrapper: {
            padding: theme.spacing(3),
            '& .MuiTextField-root': {
                margin: `${theme.spacing(1)}px 0`,
            },
        },

        mapPane: {},
    })
);
